function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Apmaksa-3",
  transform: "translate(-660.000000, -130.000000)",
  fill: "#2C9C3B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-content",
  transform: "translate(270.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(24.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "CTA",
  transform: "translate(24.000000, 44.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(342.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28,0 C34.5161846,0 39.8341075,5.21767385 39.9961936,11.6954466 L40,12 L40,28 C40,34.5161846 34.7823262,39.8341075 28.3045534,39.9961936 L28,40 L2,40 C0.946181818,40 0.0818842975,39.1854256 0.00548910594,38.1494401 L0,38 L0,12 C0,5.48381538 5.21767385,0.165892544 11.6954466,0.00380644151 L12,0 L28,0 Z M28,4 L12,4 C7.67124528,4 4.13568957,7.4538811 4.0038134,11.7511627 L4,12 L4,36 L28,36 C32.3287547,36 35.8643104,32.5461189 35.9961866,28.2488373 L36,28 L36,12 C36,7.67124528 32.5461189,4.13568957 28.2488373,4.0038134 L28,4 Z M27.586,13.586 L30.414,16.414 L18,28.828 L10.586,21.414 L13.414,18.586 L18,23.172 L27.586,13.586 Z",
  id: "icon"
})))))));

function SvgIcSuccess40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA970C10-71F5-495C-BCB9-0C89B722915E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess40);
export default __webpack_public_path__ + "static/media/ic-success-40.b01d43b1.svg";
export { ForwardRef as ReactComponent };